import { Slot } from "@radix-ui/react-slot";

import { cn } from "@/lib/utils";

interface MenuTabItemProps extends React.ComponentProps<"span"> {
  asChild?: boolean;
  icon: React.ReactNode;
  isSelected?: boolean;
}

export default function MenuTabItem({
  asChild = false,
  className,
  children,
  icon,
  isSelected = false,
  ...props
}: MenuTabItemProps) {
  const Comp = asChild ? Slot : "span";

  return (
    <li className="group relative flex cursor-pointer flex-col items-center gap-0.5 px-5 md:px-6">
      <span
        className={cn(
          "flex size-8 items-center justify-center rounded-[5px] text-white transition-colors group-hover:bg-white/10",
          isSelected && "text-rose-red"
        )}
      >
        {icon}
      </span>
      {!!children && (
        <Comp
          className={cn(
            "link-overlay line-clamp-1 font-medium text-10/[1.2em] tracking-[0.2px]",
            isSelected ? "text-rose-red" : "text-pale-lavender md:text-white",
            className
          )}
          {...props}
        >
          {children}
        </Comp>
      )}
    </li>
  );
}
